import "./AsAtSummaryComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {SimulationCalculationRecord} from "../../models/TradeSimulationRecords";
import {Simulation} from "../../models/Simulation";

import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {TradeSimulatorViewStore} from "../../service/TradeSimulatorViewStore";
import {SimulationCalculationResult} from "../../models/SimulationCalculationResult";
import {UserConfig} from "../../../types/UserConfig";
import {ReplaySubject} from "rxjs";

export const AsAsSummary = "tfSimulationAsAtSummary";

export function asAtSummary(): IComponentOptions {
    return {
        templateUrl: "app/trade-simulator/components/as-at-summary/AsAtSummaryComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: AsAtSummaryComponentController
    };
}

export class AsAtSummaryComponentController implements IOnInit, IOnDestroy {

    public viewStore: TradeSimulatorViewStore;

    public simulation: Simulation | null;
    public summary: SimulationCalculationRecord | null;
    public fees = 0;
    public feesTax = 0;
    public brokerage = 0;
    public brokerageTax = 0;
    public totalFeesAndTax = 0;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(public userConfig: UserConfig) {
    }

    public $onInit(): void {
        const sources = [this.viewStore.currentResults, this.viewStore.currentDate];
        Observable.combineLatest(...sources)
                  .takeUntil(this.destroyed$)
                  .debounceTime(200)
                  .subscribe(([result, date]) => this.updateData(result, date));
    }

    private updateData(result: SimulationCalculationResult | null, selectedDate: string | null) {
        this.summary = null;

        if (selectedDate != null && result != null) {
            const previousResults = result.summaries.filter(s => s.asAt <= selectedDate);

            if (previousResults.length > 0) {
                this.summary = previousResults[previousResults.length - 1];
                this.calculateTotalFees(this.summary);
            }
        }
    }

    private calculateTotalFees(simulationCalculation: SimulationCalculationRecord) {
        this.fees = simulationCalculation.exerciseFee + simulationCalculation.openFee;
        this.feesTax = simulationCalculation.exerciseFeeTax + simulationCalculation.openFeeTax;
        this.brokerage = simulationCalculation.brokerage;
        this.brokerageTax = simulationCalculation.brokerageTax;

        const totalFees = this.fees + this.brokerage;
        const totalTax = this.feesTax + this.brokerageTax;

        this.totalFeesAndTax = totalFees + totalTax;
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
